import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-tools" }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "card-body row" }
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = { for: "description" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_22 = { class: "form-group col-12 col-md-6" }
const _hoisted_23 = { for: "enabled" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "card-footer text-center" }
const _hoisted_26 = { class: "btn-group" }

export function render(_ctx, _cache) {
  const _component_Toggle = _resolveComponent("Toggle")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.termsUse")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.termsUse")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t("labels.page.termsUse")) + " | " + _toDisplayString(_ctx.id), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: _ctx.$t('labels.buttons.goBack')
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.description")) + " ", 1),
                _hoisted_21
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "description",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.row.description) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.description }]),
                maxlength: "100"
              }, null, 2), [
                [_vModelText, _ctx.row.description]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.description), 513), [
                [_vShow, _ctx.errors.description != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("labels.entity.active")), 1),
              _hoisted_24,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.enabled,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.row.enabled) = $event)),
                "on-label": _ctx.$t('labels.yes'),
                "off-label": _ctx.$t('labels.no')
              }, null, 8, ["modelValue", "on-label", "off-label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-sm btn-warning",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.goBack()))
              }, _toDisplayString(_ctx.$t("labels.buttons.cancel")), 1),
              _createElementVNode("button", {
                type: "button",
                id: "gravarButton",
                class: "btn btn-sm btn-success",
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.save()))
              }, _toDisplayString(_ctx.$t("labels.buttons.save")), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}